import { PropsWithChildren } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { FormResetProvider } from '@/dialogs/item-editor/Context/FormResetContext';

const MassUpdateForm = ({ children }: PropsWithChildren) => {

    const formMethods = useForm();

    return (
        <FormResetProvider>
            <FormProvider {...formMethods}>
                <form className="tw-overflow-x-hidden">
                    {children}
                </form>
            </FormProvider>
        </FormResetProvider>
    );
};

MassUpdateForm.displayName = 'MassUpdateForm';

export { MassUpdateForm };
